<template>
    <div class="student_container">
        <header class="student_header">
            <div>请绑定学生信息</div>
        </header>
        <main class="student_main">
            <section class="binding">
                <div class="binding_top">
                    <div class="iptbox">
                        <div class="required">学生身份证号/护照号</div>
                        <input v-model="message" type="text">
                    </div>
                    <div class="select">
                        <div>您与孩子的关系</div>
                        <div>
                            <div :style="active == 'PARENTS' ? activeStyle : ''" @click="onActive('PARENTS')">父母</div>
                            <div :style="active == 'GRANDPARENTS' ? activeStyle : ''" @click="onActive('GRANDPARENTS')">祖父母</div>
                            <div :style="active == 'OTHERS' ? activeStyle : ''" @click="onActive('OTHERS')">其他亲戚</div>
                        </div>
                    </div>
                </div>
                <div class="errormsg" v-if="isErr">
                    {{ errorMsg }}
                </div>
                <div class="binding_btn">
                    <van-button class="confirm" type="primary" color="#3BD3C1" @click="onConfirm()">{{ btnText }}</van-button>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import { getUserInfoApi } from "@/api/app.js";
import { bindStudentIdApi } from "../../api/studentBinding";
import { async } from "q";
export default {
  data() {
    return {
      message: "",
      active: "PARENTS",
      errorMsg: "请输入学生身份证号！",
      activeStyle: {
        color: "#ffffff",
        background: "#3BD3C1"
      },
      isErr: false,
      btnText: "确定"
    };
  },
  mounted() {
    console.log(6);
  },
  beforeDestroy() {
    this.message = "";
  },
  methods: {
    onActive(id) {
      this.active = id;
    },
    onConfirm() {
      if (this.btnText == "确定") {
        if (!this.message.length) {
          this.isErr = true;
          this.errorMsg = "请输入身份证号或护照号！";
          return;
        }
        // if (
        //   this.message.length != 18 ||
        //   !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        //     this.message
        //   )
        // ) {
        //   this.isErr = true;
        //   this.errorMsg = "无效身份证号码！";
        //   return;
        // }

        bindStudentIdApi({
          idcard: this.message,
          relation: this.active
        })
          .then(res => {
            if (res.code == 50005) {
              this.isErr = true;
              this.errorMsg = "家长与学生关系错误！";
              this.btnText = "返回";
              return;
            }
            if (res.code == 50006) {
              this.isErr = true;
              this.errorMsg = "该学生档案不存在！";
              this.btnText = "返回";
              return;
            }
            if (res.code == 50007) {
              this.isErr = true;
              this.errorMsg = "绑定学生已达到上限！";
              this.btnText = "返回";
              return;
            }
            if (res.code == 50008) {
              this.isErr = true;
              this.errorMsg = "您已绑定该学生！";
              this.btnText = "返回";
              return;
            }
            getUserInfoApi().then(res => {
              if (JSON.stringify(res.data) != "{}" && JSON.stringify(res.data.student) != "{}") {
                if (
                  typeof res.data.student.studentId == "object" &&
                  res.data.student.studentId.c
                ) {
                  id = res.data.student.studentId.toString();
                  this.$store.commit("app/SET_STUDENTID", id);
                  this.$store.commit("app/SET_NAME", res.data.student.name);
                  this.$store.commit("app/SET_GENDER", res.data.student.gender);
                } else {
                  this.$store.commit(
                    "app/SET_STUDENTID",
                    res.data.student.studentId
                  );
                  this.$store.commit("app/SET_NAME", res.data.student.name);
                  this.$store.commit("app/SET_GENDER", res.data.student.gender);
                }
                this.$store.commit("app/SET_NICKNAME", res.data.user.nickname);
                this.$store.commit("app/SET_OPENID", res.data.user.openId);
                this.$toast({
                  type: "success",
                  message: "绑定成功",
                  onClose: () => {
                    if (this.$route.query && this.$route.query.name) {
                      this.$router.push({ name: this.$route.query.name });
                    } else {
                      this.$router.push("/");
                    }
                  }
                });
              } else {
                this.$toast({
                  type: "fail",
                  message: "绑定失败,未获取到学生信息",
                  onClose: () => {
                    this.$router.push("/");
                  }
                });
              }
            });
          })
          .catch(err => {
            console.log(err);
            return Promise.reject(err);
          });
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style scoped>
.required::after {
  content: "*";
  margin-left: 0.04rem;
  color: #3bd3c1;
  font-size: 0.14rem;
}
.student_container {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.student_header {
  height: 1.3rem;
  border-radius: 0 0 0.2rem 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #3bd3c1;
}

.student_header > div {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.24rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.student_main {
  width: 100%;
  position: absolute;
  top: 1.04rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.binding {
  width: calc(100vw - 0.2rem);
  height: 2.93rem;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
}

.binding_top {
  height: 1.86rem;
  padding-left: 0.2rem;
  display: flex;
  flex-direction: column;
}

.iptbox {
  height: 0.67rem;
  padding: 0.1rem 0.2rem 0.12rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.iptbox > div:first-child {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #505050;
  letter-spacing: 0;
  font-weight: 400;
}

.iptbox > div:first-child::after {
  content: "*";
  margin-left: 0.04rem;
  color: #3bd3c1;
  font-size: 0.14rem;
}

.iptbox > input {
  height: 0.36rem;
  border: 0;
  padding: 0;
  background-color: #e0edeb;
  text-indent: 0.1rem;
  border-radius: 0.04rem;
}

.select {
  height: 0.96rem;
  border-top: 0.01rem solid #f5f5f5;
}

.select > div:first-child {
  margin: 0.1rem 0;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #505050;
  letter-spacing: 0;
  font-weight: 400;
}

.select > div:nth-child(2) {
  padding-right: 0.2rem;
  display: flex;
  justify-content: space-between;
}

.select > div:nth-child(2) > div {
  width: 0.9rem;
  height: 0.36rem;
  background-color: #e0edeb;
  border-radius: 0.04rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #707070;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.binding_btn {
  height: 0.87rem;
  padding: 0 0.2rem;
  border-top: 0.01rem solid #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm {
  width: 100%;
  height: 0.48rem;
  border-radius: 0.1rem;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.16rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}

.errormsg {
  text-indent: 0.2rem;
  font-size: 0.16rem;
  color: #ff5e5e;
  padding-bottom: 0.18rem;
}
</style>